// IE Hub - Public Environment (Frontend-safe) Configuration
// Vite injects `import.meta.env.VITE_*` at build time. If a key is not set at build time,
// it can be `undefined` at runtime. This module centralizes safe fallbacks for keys
// that are required by the client bundle (Firebase, Maps, etc.).

export interface PublicFirebaseEnv {
  readonly apiKey: string;
  readonly authDomain: string;
  readonly projectId: string;
  readonly storageBucket: string;
  readonly messagingSenderId: string;
  readonly appId: string;
  readonly vapidKey: string;
}

export interface PublicEnv {
  readonly firebase: PublicFirebaseEnv;
  readonly googleMapsApiKey: string;
  readonly appVersion: string;
  readonly hideUu: boolean;
}

const readNonEmptyString = (value: unknown, fallback: string): string => {
  if (typeof value === "string") {
    const trimmed = value.trim();
    if (trimmed.length > 0) return trimmed;
  }
  return fallback;
};

const readBoolean = (value: unknown, fallback: boolean): boolean => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["true", "1", "yes", "y", "on"].includes(normalized)) return true;
    if (["false", "0", "no", "n", "off", ""].includes(normalized)) return false;
  }
  return fallback;
};

// NOTE: These defaults match `iehub-customer-v3/.env copy`.
const DEFAULT_PUBLIC_ENV: PublicEnv = {
  firebase: {
    apiKey: "AIzaSyC7V62ad57WzfCtwYv4N7xWkfFWjPPQFsM",
    authDomain: "iehub-c496d.firebaseapp.com",
    projectId: "iehub-c496d",
    storageBucket: "iehub-c496d.firebasestorage.app",
    messagingSenderId: "508140504690",
    appId: "1:508140504690:web:6eee513aa818374bfca4eb",
    vapidKey:
      "BI-aEpqMkonZfX0sFc0s9zIfUIxqgY0Qtm2rsJRS2lbgJhpvwQAaDC0Biv3VdoJAD6DqR5AxsXsKJLg41kgwfjI",
  },
  googleMapsApiKey: "AIzaSyCECfa6ULzL0y-pmBVq8WDAd8VbhH8tQZ8",
  appVersion: "v3.3.4",
  hideUu: false,
};

export const PUBLIC_ENV: PublicEnv = {
  firebase: {
    apiKey: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_API_KEY,
      DEFAULT_PUBLIC_ENV.firebase.apiKey,
    ),
    authDomain: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      DEFAULT_PUBLIC_ENV.firebase.authDomain,
    ),
    projectId: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_PROJECT_ID,
      DEFAULT_PUBLIC_ENV.firebase.projectId,
    ),
    storageBucket: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      DEFAULT_PUBLIC_ENV.firebase.storageBucket,
    ),
    messagingSenderId: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      DEFAULT_PUBLIC_ENV.firebase.messagingSenderId,
    ),
    appId: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_APP_ID,
      DEFAULT_PUBLIC_ENV.firebase.appId,
    ),
    vapidKey: readNonEmptyString(
      import.meta.env.VITE_FIREBASE_VAPID_KEY,
      DEFAULT_PUBLIC_ENV.firebase.vapidKey,
    ),
  },
  googleMapsApiKey: readNonEmptyString(
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    DEFAULT_PUBLIC_ENV.googleMapsApiKey,
  ),
  appVersion: readNonEmptyString(
    import.meta.env.VITE_APP_VERSION,
    DEFAULT_PUBLIC_ENV.appVersion,
  ),
  hideUu: readBoolean(
    import.meta.env.VITE_HIDE_UU ?? import.meta.env.HIDE_UU,
    DEFAULT_PUBLIC_ENV.hideUu,
  ),
};
